module.exports = __webpack_public_path__ + "94c997749cf12669ac9412ef257527bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-30.png
// module id = 2643
// module chunks = 0